import { atom } from 'recoil';

export const ShowVr360State = atom({
    key: 'ShowVr360State',
    default: {
        show: false,
        subTitle: ''
    }
});